export const filterChinese = (value) => value.replace(/[\u4e00-\u9fa5\u3000-\u303f\uff00-\uffef]/g, "");
export const validatePassword = (value) => {
    if (value.length < 8 || value.length > 20)
        return "length";
    if (/\s/.test(value))
        return "composition";
    const kinds = [/[A-Z]/, /[a-z]/, /\d/, /[^A-Za-z0-9\s]/].filter((rule) => rule.test(value)).length;
    return kinds >= 3 ? null : "composition";
};
export const isEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
//# sourceMappingURL=password.js.map